export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  teams: {
    status: Status.STATUS_INITIAL,
    data: []
  },
  users: {
    status: Status.STATUS_INITIAL,
    activitiesDataStatus: Status.STATUS_INITIAL, // indicate user's activities data is loaded yet?
    data: []
  }
};

export default function userManagementReducer(state = initialState, action) {
  const { STATUS_LOADING, STATUS_LOADED } = Status;

  switch (action.type) {
    case ActionType.SET_ACTIVITIES_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          users: {
            ...state.users,
            activitiesDataStatus: status
          }
        }
      }
    case ActionType.SET_ORG_USERS_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          users: {
            ...state.users,
            status
          }
        }
      }
    case ActionType.SET_TEAMS_STATUS:
      {
        const { status } = action.payload;
        return {
          ...state,
          teams: {
            ...state.teams,
            status
          }
        }
      }

    case ActionType.CREATE_TEAM:
      {
        const { teams } = state;
        teams.status = STATUS_LOADING;
        return {
          ...state,
          teams
        }
      }
    case ActionType.UPDATE_TEAM:
      {
        const { teams } = state;
        teams.status = STATUS_LOADING;
        return {
          ...state,
          teams
        }
      }
    case ActionType.SET_ORG_USERS:
      {
        const { users } = action.payload;
        return {
          ...state,
          users: {
            ...state.users,
            status: STATUS_LOADED,
            data: [...users]
          }
        }
      }
    case ActionType.SET_TEAMS:
      {
        const { teams } = action.payload;
        return {
          ...state,
          teams: {
            status: STATUS_LOADED,
            data: [...teams]
          }
        }
      }
    default:
      return state;
  }
}

